import PropTypes from 'prop-types';

const MobileTopBarSchema = {
  toggleNavigation: PropTypes.func.isRequired,
};

export default { MobileTopBarSchema };
